<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<idt-common-styles-render
  *ngIf="piece"
  [styles]="piece.settings?.styles">

  <ng-container *idtLet="(orientation$ | async) as orientation">
    <render-link
      *ngIf="!!settings && !!settings.general.link.type"
      [analyticsEventName]="analyticsEventClickImage"
      [analyticsEventData]="analyticsEventData"
      [lang]="lang"
      [link]="settings.general.link"
      [piece]="piece"
      (renderLinkEvent)="onRenderLinkClick($event)">
      <ng-container *ngTemplateOutlet="imageSelector"></ng-container>
    </render-link>

    <ng-container *ngIf="!!settings && !settings.general.link.type">
      <ng-container *ngTemplateOutlet="imageSelector"></ng-container>
    </ng-container>

    <ng-template #imageSelector>
      <img
        *ngIf="orientation === 'landscape'"
        [lazySrc]="getLandscapeImageSrc()"
        [preRender]="!!settings.general.preloadImage"
        [attr.alt]="settings.general.alt"
        alt=""
        [attr.title]="settings.general.title" />

      <img
        *ngIf="orientation === 'portrait'"
        [lazySrc]="getPortraitImageSrc()"
        [preRender]="!!settings.general.preloadImage"
        [attr.alt]="settings.general.alt"
        alt=""
        [attr.title]="settings.general.title">
    </ng-template>
  </ng-container>
</idt-common-styles-render>
